import React from 'react';

import css from './SingleAdvice.module.scss';

const SingleAdvice = ({ src, alt, heading, description }) => {
	return (
		<div className={css.card} data-aos="fade-up">
			<img src={`/images/home/financial-advice/${src}`} alt={alt} />
			<div className={css.about}>
				<h5>{heading}</h5>
				<p>{description}</p>
			</div>
		</div>
	);
};

export default SingleAdvice;
